import { Injectable } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import {
  Http,
  ResponseContentType
} from "@angular/http";
@Injectable()
export class MainService {
  constructor(private auth: AuthenticationService, private http: Http) { }
  //---------------Group------------------------//
  Save_Group(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Save_Group",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Update_Group(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Update_Group",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_Group_ById(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_Group_ById",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_Group(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_Group",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_CompanystructureForTree(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_CompanystructureForTree", model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_GroupForTree(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_GroupForTree",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_GroupByIdForTree(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_GroupByIdForTree",
        model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_GenerateGroupCode() {
    return this.http.get(this.auth.baseUrl + "/services/api/v1/Get_GenerateGroupCode", this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_CompanyStructureForConsolidateReport(model: any) {
    return this.http.
      post(this.auth.baseUrl + "/services/api/v1/Get_CompanyStructureForConsolidateReport", model,
        this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_UserAccessLocations(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UserAccessLocations",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Group------------------------//
  //---------------Location------------------------//
  GetLocations(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LocationByGroup",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getLocationById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LocationById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLocationBybranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LocationByBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetLocationByCompany(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LocationByCompany",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetAllLocation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetAllLocation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateLocation(LocMaster: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Update_Location", LocMaster, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  SaveLocation(LocMaster: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Save_Location", LocMaster, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  DeleteLocation(Id: any) {
    return this.http.get(this.auth.baseUrl + "/services/api/v1/Delete_Location?Id=" + Id, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  GenerateLocationCode(BranchId: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_GenerateLocationCode", BranchId, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_LocationByRestItemLevel(filter: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_LocationByRestItemLevel", filter, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  //---------------Location------------------------//
  //---------------Branch------------------------//
  GetBranchById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BranchById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetBranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Branch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  SaveBranch(BranchModel: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/save_Branch", BranchModel, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  UpdateBranch(BranchModel: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Update_Branch", BranchModel, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  GenerateBranchCode(CompanyId: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_GenerateBranchCode", CompanyId, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_BranchForTree(CompanyId: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_BranchForTree", CompanyId, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  //---------------Branch------------------------//
  //---------------Company------------------------//
  GetCompanyById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CompanyById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetCompany(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Company",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetCompanyStrecture(model) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetCompanyStecture",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_Company(CompanyMaster: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Save_Company",
      CompanyMaster,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }


  UpdateCompany(CompanyMaster: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Update_Company", CompanyMaster, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_CompanyForTree(CompanyMaster: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_CompanyForTree", CompanyMaster, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }

  Get_GenerateCompanyCode(Id: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_GenerateCompanyCode", Id, this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Save_TransactionPeriod(model: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Save_TransactionPeriod",
      model,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Update_TransactionPeriod(model: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Update_TransactionPeriod",
      model,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Get_TransactionPeriodByCompany(model: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_TransactionPeriodByCompany",
      model,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Save_AccountPeriod(model: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Save_AccountPeriod",
      model,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  Validate_TransactionPeriod(model: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Validate_TransactionPeriod",
      model,
      this.auth.getHeader())
      .map(res => {
        return res.json();
      });
  }
  //---------------Company------------------------//
  //---------------User Settings------------------------//
  GetUSer(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetUsers",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetUSerbyId(Id: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/GetUserById?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveUser(UserMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/api/Account/Register",
        UserMaster,
        this.auth.getnoauthHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateUser(UserMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/api/Account/ChangePassword",
        UserMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteUser(Id: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Delete_User?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetRole(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetRole",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //16-10-2021 Nithin
  Activate_User(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Activate_User",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_UserDataForActive(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UserDataForActive",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  saveRole(RoleMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Role",
        RoleMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteRole(Id: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Delete_Role?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetUserRole(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetUserRole",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetUserNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/GetUserNo",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveUserRole(requestedlist: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_UserRole",
        requestedlist,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getUserRoleSearch(RoleMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UserRoleSearch",
        RoleMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteUserRoleSet(detailsIdlist: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_UserRoleSet", detailsIdlist,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getUserforms(RoleMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetUserForms",
        RoleMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getformPrivilegeByFromId(RoleMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetFormPrivilegeByFormId",
        RoleMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveUserPrivilege(PrivilegeMaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_UserPrivilege",
        PrivilegeMaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Check_SuperUserRole(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Check_SuperUserRole",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Check_UserIsActive(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/Check_UserIsActive",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------User Settings------------------------//

  //--------------CountryStateCity----------------------//

  GetCountryList() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/GetCountryList",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetStateByCountry(CountryId: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/GetStateByCountry?CountryId=" + CountryId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_Country(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Country",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_StateList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StateList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_StateListByCountry(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StateListByCountry",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_Country(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Country",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_Country(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_Country",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_State(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_State",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_State(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_State",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------End CountryStateCity------------------//
  //------------- Rest Info------------------//
  Get_RestInfoByLocId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestInfoByLocId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_RestInfo(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestInfo",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RoomForRestInfo(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RoomForRestInfo",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------End Rest Info------------------//
  //-------------common settings------------------//
  Get_SettingsDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SettingsDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SettingsDetailsBySettingId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SettingsDetailsBySettingId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_Settings(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Settings",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_SettingsDetailsByMasterId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SettingsDetailsByMasterId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------End common settings--------------//

  //-------------End generate item relation--------------//
  Save_SupplierItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SupplierItem",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_SellingPrice(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SellingPrice",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_ItemControll(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ItemControll",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_ReorderLevel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ReorderLevel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------End generete item relation--------------//

  //-------------Report Menu-----------------------------//
  Get_ReportMenu(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReportMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_ReportMenu(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ReportMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ReportPermission(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ReportPermission",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ReportPermission(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ReportPermission",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_SingleReportMenu(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SingleReportMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SingleReportMenu(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SingleReportMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReportMenuType() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReportMenuType",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReportModule() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReportModule",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------Report Menu-----------------------------//
  //--------------Backup database----------------------//

  Get_DatabaseBackUp(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DatabaseBackUp",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Download_DatabaseBackUp(model: any) {
    var httpo = { resposeType: 'blog' as 'json' }
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Download_DatabaseBackUp", model,
      {
        responseType: ResponseContentType.Blob
      })
  }

  //--------------Backup database----------------------//
  //--------------Customer Support---------------------//
  Get_SupportQrCode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SupportQrCode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Customer Support---------------------//
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/main.service.ts